/* eslint-disable jira/filename-case */
import {
	ExperiencePerformanceTypes,
	ExperienceTypes,
	UFOExperience,
} from '@atlassian/ufo/ufo-experimental';
import { createJpdExperience } from './createJpdExperience.tsx';
import type { JPDExperience } from './ExperienceMetadataExtra.types.tsx';

export const updatePlayField: JPDExperience = createJpdExperience(
	new UFOExperience('jpd.play-sidepanel.field-update', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);
